module.exports = __webpack_public_path__ + "static/media/opensanshebrew-light.d30b6d41.woff2";